// extracted by mini-css-extract-plugin
export default {"skeletonSquareItem":"SkeletonSquareItem_skeletonSquareItem__8bvij","squareImg":"SkeletonSquareItem_squareImg__tiiKm"};